export default [
    {
        path: 'myRequests',
        name: 'MYREQUESTS',
        component: resolve => require(['@/view/cmr_refactor/myRequests/index.vue'], resolve)
    },
    {
        path: 'todolist',
        name: 'MYTODOLIST',
        component: resolve => require(['@/view/cmr_refactor/todolist/index.vue'], resolve)
    },
    {
        path: 'ticket-details',
        name: 'TICKETDETAIL',
        component: resolve => require(['@/view/cmr_refactor/ticketDetail/index.vue'], resolve)
    },
    {
        path: 'trad-fund',
        name: 'TRADEFUND',
        component: resolve => require(['@/view/cmr_refactor/my-responsibility/tradeFund/index.vue'], resolve)
    },
    {
        path: 'training',
        name: 'TRAINING',
        component: resolve => require(['@/view/cmr_refactor/training/index.vue'], resolve)
    },
    {
        path: '/cmr/usecase',
        name: 'USECASELIST',
        component: resolve => require(['@/view/cmr_refactor/useCase/index.vue'], resolve)
    },
    {
        path: '/cmr/customerCodeApplication',
        name: 'CustomerCodeApplication',
        component: resolve => require(['@/view/cmr/customer-code-application/index.vue'], resolve)
    },
    {
        path: '/cmr/customerCodeCreate',
        name: 'CustomerCodeCreate',
        component: resolve => require(['@/view/cmr/customer-code-application/Create/Create.vue'], resolve)
    },
    {
        path: '/cmr/customerCodeDTC',
        name: 'CustomerCodeDTC',
        component: resolve => require(['@/view/cmr/customer-code-application/DTC/index.vue'], resolve)
    },
    {
        path: '/cmr/customerCodeChange',
        name: 'CustomerCodeChange',
        component: resolve => require(['@/view/cmr/customer-code-application/Change/index.vue'], resolve)
    },
    {
        path: '/cmr/dsts-new',
        name: 'CustomerCodeDSTSNew',
        component: resolve => require(['@/view/cmr/customer-code-application/DSTS/creation/index.vue'], resolve)
    },
    {
        path: '/cmr/customerCodeInactive',
        name: 'CustomerCodeInactive',
        component: resolve => require(['@/view/cmr/customer-code-application/Inactive/index.vue'], resolve)
    },
    {
        path: '/cmr/customerCodeAdd',
        name: 'CustomerCodeAdd',
        component: resolve => require(['@/view/cmr/customer-code-application/Add/index.vue'], resolve)
    },
]


// WEBPACK FOOTER //
// ./src/router/cmr.js